export const width = 80;
export const height = 80;
export default __webpack_public_path__ + "static/address.3b50aeb4.svg";